// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { JOB_BASE_URL } from "../services/jobService";
// import { format, set } from "date-fns";
// import ReactMarkdown from "react-markdown";

// import { useAuthContext } from "../hooks/useAuthContext";
// import axios from "axios";
// import Loading from "../utils/Loading";

// import Swal from "sweetalert2";

// const JobDetails = () => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [applied, setApplied] = useState(false);

//   const { user } = useAuthContext();
//   const navigate = useNavigate();
//   const { id } = useParams();

//   const [job, setJob] = useState({
//     jobTitle: "",
//     employmentType: "",
//     remoteType: "",
//     salary: 0,
//     description: "",
//     companyName: "",
//     location: {
//       city: "",
//       state: "",
//       country: "",
//     },
//     createdAt: new Date(),
//     updatedAt: "",
//   });

//   // Apply for Job (To be implemented)
//   const ApplyForJob = async (e, id, jobTitle) => {
//     e.preventDefault();
//     setLoading(true);

//     if (!user || !user.token) {
//       // Save the job ID and jobTitle in localStorage before redirecting
//       localStorage.setItem("pendingJobApplication", id);
//       localStorage.setItem("pendingJobTitle", jobTitle);
//       navigate("/api/users/login"); // Redirect to login
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${JOB_BASE_URL}/api/jobs/apply/${id}`,
//         {},
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${user.token}`,
//           },
//         }
//       );

//       if (response.status === 200 || response.status === 204) {
//         setApplied(true);
//         Swal.fire({
//           title: "Success!",
//           text: "You have successfully applied for the job.",
//           icon: "success",
//           timer: 5000,
//         });
//         navigate("/api/jobs/all-jobs"); // Redirect after application
//       } else {
//         setError("Unable to apply for job!");
//       }
//     } catch (error) {
//       console.error("Application error:", error.response?.data);
//       setError(error.response?.data?.error || "Failed to apply for job.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Delete a Job
//   const DeleteAJob = async (e, id) => {
//     e.preventDefault();
//     try {
//       const confirmResult = await Swal.fire({
//         title: "Are you sure?",
//         text: "You won't be able to revert this!",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes, delete it!",
//       });

//       if (confirmResult.isConfirmed) {
//         const response = await axios.delete(
//           `${JOB_BASE_URL}/api/jobs/list/delete/${id}`,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${user.token}`,
//             },
//           }
//         );
//         Swal.fire({
//           title: "Deleted!",
//           text: "A job has been deleted.",
//           icon: "success",
//           timer: 4000,
//         });

//         setTimeout(() => {
//           navigate("/api/jobs/all-jobs");
//         }, 2000);
//       }
//     } catch (error) {
//       console.error("Error deleting job: ", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to delete this job!",
//         icon: "error",
//         timer: 2000,
//       });
//     }
//   };

//   // Fetch Job Data
//   const fetchJobData = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${JOB_BASE_URL}/api/jobs/list/${id}`);
//       // Axios does not have response.ok, instead, check response.status
//       if (response.status !== 200) {
//         throw new Error("Failed to fetch job data!");
//       }
//       setJob(response.data); // No need for response.json()
//       setLoading(false);
//     } catch (error) {
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchJobData();
//   }, [id, JOB_BASE_URL]);

//   return (
//     <div className="container my-5">
//       {applied && (
//         <div className="alert alert-success">
//           You have successfully applied for this job!
//         </div>
//       )}

//       {loading ? (
//         <Loading />
//       ) : error ? (
//         <div className="alert alert-danger">{error}</div>
//       ) : (
//         <div className="card shadow-lg">
//           <div className="card-header d-flex justify-content-between align-items-center">
//             <h3 className="m-0">Job Details</h3>
//             <div className="d-flex">
//               <Link to="/api/jobs/all-jobs" className="btn btn-link mr-2">
//                 Search for Jobs
//               </Link>
//             </div>
//           </div>
//           <div className="card-body">
//             <h3>{job.jobTitle}</h3>
//             <p>
//               <b>Location:</b> {job.location.city}, {job.location.state},{" "}
//               {job.location.country} <br />
//               <b>Company:</b> {job.companyName}
//             </p>
//             <hr />
//             <h5>Job Specs</h5>
//             <ul>
//               <li>
//                 <b>Date Posted:</b>{" "}
//                 {format(new Date(job.createdAt), "MMMM d, yyyy")}
//               </li>
//               <li>
//                 <b>Salary:</b>{" "}
//                 {new Intl.NumberFormat("en-US", {
//                   style: "currency",
//                   currency: "USD",
//                 }).format(job.salary || 0)}
//               </li>
//               <li>
//                 <b>Employment Type:</b> {job.employmentType}
//               </li>
//               <li>
//                 <b>Work Type:</b> {job.remoteType}
//               </li>
//             </ul>

//             <h5>Job Description</h5>

//             <p className="text-muted">
//               <ReactMarkdown children={job.description && job.description} />
//             </p>

//             <div className="d-flex justify-content-between">
//               <button
//                 className="btn btn-primary"
//                 onClick={(e) => ApplyForJob(e, id, job.jobTitle)}
//               >
//                 Apply Now
//               </button>

//               {(user?.isAdmin || user?.role === "SuperAdmin") && (
//                 <Link to={`/api/jobs/list/update/${id}`}>
//                   <button className="btn btn-primary">Edit Job</button>
//                 </Link>
//               )}

//               {user?.isAdmin && (
//                 <button
//                   className="btn btn-danger btn-sm"
//                   onClick={(e) => DeleteAJob(e, id)}
//                   disabled={loading}
//                 >
//                   {loading ? "Deleting..." : "Delete"}
//                 </button>
//               )}
//               {user && user.token ? (
//                 <button className="btn btn-secondary">Save Job</button>
//               ) : (
//                 ""
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default JobDetails;


import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { JOB_BASE_URL } from "../services/jobService";
import { format } from "date-fns";
import ReactMarkdown from "react-markdown";
import { useAuthContext } from "../hooks/useAuthContext";
import axios from "axios";
import Loading from "../utils/Loading";
import Swal from "sweetalert2";

const JobDetails = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [applied, setApplied] = useState(false);
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const { id } = useParams();

  const [job, setJob] = useState({
    jobTitle: "",
    employmentType: "",
    remoteType: "",
    salary: 0,
    description: "",
    companyName: "",
    location: {
      city: "",
      state: "",
      country: "",
    },
    createdAt: new Date(),
    updatedAt: "",
  });

  const ApplyForJob = async (e, id, jobTitle) => {
    e.preventDefault();
    setLoading(true);

    if (!user || !user.token) {
      localStorage.setItem("pendingJobApplication", id);
      localStorage.setItem("pendingJobTitle", jobTitle);
      navigate("/api/users/login");
      return;
    }

    try {
      const response = await axios.post(
        `${JOB_BASE_URL}/api/jobs/apply/${id}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 204) {
        setApplied(true);
        Swal.fire({
          title: "Success!",
          text: "You have successfully applied for the job.",
          icon: "success",
          timer: 5000,
        });
        navigate("/api/jobs/all-jobs");
      } else {
        setError("Unable to apply for job!");
      }
    } catch (error) {
      console.error("Application error:", error.response?.data);
      setError(error.response?.data?.error || "Failed to apply for job.");
    } finally {
      setLoading(false);
    }
  };

  const DeleteAJob = async (e, id) => {
    e.preventDefault();
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (confirmResult.isConfirmed) {
        const response = await axios.delete(
          `${JOB_BASE_URL}/api/jobs/list/delete/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        Swal.fire({
          title: "Deleted!",
          text: "A job has been deleted.",
          icon: "success",
          timer: 4000,
        });

        setTimeout(() => {
          navigate("/api/jobs/all-jobs");
        }, 2000);
      }
    } catch (error) {
      console.error("Error deleting job: ", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to delete this job!",
        icon: "error",
        timer: 2000,
      });
    }
  };

  const fetchJobData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${JOB_BASE_URL}/api/jobs/list/${id}`);
      if (response.status !== 200) {
        throw new Error("Failed to fetch job data!");
      }
      setJob(response.data);
      setLoading(false);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobData();
  }, [id, JOB_BASE_URL]);

  return (
    <div className="container py-5">
      {applied && (
        <div className="alert alert-success alert-dismissible fade show mb-4">
          <i className="fa fa-check-circle me-2"></i>
          You have successfully applied for this job!
          <button
            type="button"
            className="btn-close"
            onClick={() => setApplied(false)}
          ></button>
        </div>
      )}

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Loading />
        </div>
      ) : error ? (
        <div className="alert alert-danger">
          <i className="fa fa-exclamation-circle me-2"></i>
          {error}
        </div>
      ) : (
        <div className="card border-0 shadow-lg">
          <div className="card-header bg-primary text-white">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h2 className="mb-0">
                  {/* <i className="fa fa-briefcase me-2"></i> */}
                  {job.jobTitle}
                </h2>
                <p className="mb-0">
                  <i className="fa fa-building me-2"></i>
                  {job.companyName}
                </p>
              </div>
              <Link
                to="/api/jobs/all-jobs"
                className="btn btn-light btn-sm text-primary"
              >
                <i className="fa fa-arrow-left me-1"></i> Back to Jobs
              </Link>
            </div>
          </div>

          <div className="card-body">
            <div className="row mb-4">
              <div className="col-md-6">
                <div className="d-flex align-items-center mb-3">
                  <i className="fa fa-map-marker text-primary me-2 fs-5"></i>
                  <div>
                    <h5 className="mb-0">Location</h5>
                    <p className="mb-0">
                      {job.location.city}, {job.location.state},{" "}
                      {job.location.country}
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-3">
                  <i className="fa fa-clock-o text-primary me-2 fs-5"></i>
                  <div>
                    <h5 className="mb-0">Employment Type</h5>
                    <p className="mb-0">{job.employmentType}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex align-items-center mb-3">
                  <i className="fa fa-money text-primary me-2 fs-5"></i>
                  <div>
                    <h5 className="mb-0">Salary</h5>
                    <p className="mb-0">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(job.salary || 0)}
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-3">
                  <i className="fa fa-home text-primary me-2 fs-5"></i>
                  <div>
                    <h5 className="mb-0">Work Type</h5>
                    <p className="mb-0">{job.remoteType}</p>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div className="mb-4">
              <h4 className="mb-3">
                <i className="fa fa-file-text-o me-2"></i>Job Description
              </h4>
              <div className="bg-light p-4 rounded">
                <ReactMarkdown children={job.description && job.description} />
              </div>
            </div>

            <div className="mb-3">
              <small className="text-muted">
                <i className="fa fa-calendar me-1"></i> Posted:{" "}
                {format(new Date(job.createdAt), "MMMM d, yyyy")}
              </small>
            </div>

            <div className="d-flex flex-wrap gap-3 mt-4">
              <button
                className="btn btn-primary px-4"
                onClick={(e) => ApplyForJob(e, id, job.jobTitle)}
                disabled={applied}
              >
                <i className="fa fa-paper-plane me-2"></i>
                {applied ? "Applied" : "Apply Now"}
              </button>

              {user?.token && (
                <button className="btn btn-outline-secondary px-4">
                  <i className="fa fa-bookmark me-2"></i> Save Job
                </button>
              )}

              {(user?.isAdmin || user?.role === "SuperAdmin") && (
                <>
                  <Link
                    to={`/api/jobs/list/update/${id}`}
                    className="btn btn-outline-primary px-4"
                  >
                    <i className="fa fa-pencil me-2"></i> Edit Job
                  </Link>
                  <button
                    className="btn btn-outline-danger px-4"
                    onClick={(e) => DeleteAJob(e, id)}
                    disabled={loading}
                  >
                    <i className="fa fa-trash me-2"></i>
                    {loading ? "Deleting..." : "Delete"}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobDetails;